/*!
 *  2018-8-7 09:20:06
 *  Copyright 2018 FT, DK Techin Corp 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $coll = (0, _jquery2['default'])('#cfrColl');
	var $tvList = $coll.find('.list_thumb li');
	var $pagingNav = $coll.find('.paging_nav');
	var listViewCount = 4; // 리스트 아이템 갯수
	var wideListViewCount = 3; // 리스트 아이템 갯수
	var $body = (0, _jquery2['default'])('body');
	var pagingHideNum = $body.hasClass('wide') ? wideListViewCount : listViewCount;
	
	// 리스트 페이징
	var pager = new SF.pager({
	  navigation: $pagingNav,
	  list: $tvList,
	  viewCount: listViewCount,
	  wideViewCount: wideListViewCount,
	  isInfinite: false
	});
	
	// 아이템 갯수 wide에 유무 따라 3||4 개 이하면 페이징 숨김.
	if ($tvList.length <= pagingHideNum) {
	  $pagingNav.addClass('hide');
	}
	
	//총페이지수 재설정
	$coll.find('.paging_nav .total_page').text(Math.ceil($tvList.length / listViewCount));

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** CFR/CFR.bundle.aa43c32.js
 **/